import ModalClass from "common/utils/ui/modal-class";
import "./digital-assets-license-modal.scss";

export default () =>
  new ModalClass({
    modalSelector: "#digital-assets-license-modal"
  });
